export enum EValidateActionTypes {
  ValidateAll = 'validateAll',
  ValidateByField = 'validateByField',
  ResetState = 'resetState',
}
